module.exports = __webpack_public_path__ + "img/hnjt.c51e7a9b.jpg";